<template>
    <div class="evaluate-box">
       
    <van-nav-bar safe-area-inset-top
        left-arrow
        @click-left="resultClick"
        @click-right="onClickRight"
        title="我的反馈"
        right-text="问题反馈"
      
        fixed
      /> 
      <div class="div-conter">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" >
            <van-list  v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"  :immediate-check="false" >
                <div v-for="(item, index) in list" :key="index"   class="borderCss" >
                    <div  @click="detail(item)" style="display: flex; justify-content: space-between;padding: 10px 16px;align-items: center;    background-color: white;">
                        <div style="display: flex;     align-items: center;">
                            <div style="font-size: 13px;font-weight: 600;">{{item.pfTypeStr}}</div>
                            <div class="icon-circleThree" style=" margin-left: 15px;"  v-show="item.pfStatus==1 ">
                                <span class="icon-circle-class">{{ item.pfStatus==1 ?'已解决':'未解决' }}</span>
                             </div>
                           
                        </div>
                        <div style="font-size: 13px;    color: #bfbfbf;">{{item.pfTimeStr}}</div>
                    </div>
                    <div  @click="detail(item)" style="font-size: 13px;    color: #bfbfbf;padding: 5px 16px 20px 16px;background-color: white; overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{item.pfDesc}}</div>
                </div>
            </van-list>   
     </van-pull-refresh>
      </div>
    </div>

</template>
<script>
import Api from "../../api/api";
import { Toast } from 'vant';
import {formatDate} from "../../common/date";
export default {
    data() {
        return {
            list: [], // 反馈列表
            loading: false, // 加载状态
            finished: false, // 是否数据全部加载完成
            refreshing: false,// 是否刷新页面
            page: 1,// 页码
            limit: 10,//一页行数
            orderField:'CREATE_DATE', //默认排序 
            order:'desc', //降序
        };

    },

    mounted() {
    
  
  },

  created(){
      this.onLoad();
    },

      

  methods: {
    resultClick() {
      this.$router.go(-1)
    },

    onClickRight() {
      this.$router.push('/app-h5-cn/page/feedback');
    },

      // 	下拉重新刷新时触发
     onRefresh() {  
        // 清空列表数据
        this.finished = false;
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true;
        this.page=1;
        this.list = [];
        this.refreshing = false;
        this.onLoad();
      },

      async  onLoad() {
      

            let data = {
            page: this.page,
            limit: this.limit,
            orderField:this.orderField,
            order:this.order,
            webType:1,
          //  searchKey:this.searchKey,
         };  
         let self = this; 
         await     Api.queryProblemfeedBackList(data).then((res) => {
            debugger
          if (res.data.success) {
            let  dataTotal= res.data.result.total;  // 查询数据总数
            let pageList= res.data.result.list;

            for (let i = 0; i < pageList.length; i++) {
                let obj=pageList[i];    
                obj.pfTimeStr=formatDate(obj.pfTime,'yyyy-MM-dd');
                if(obj.pfType==10341001){
                  obj.pfTypeStr='要求删除配方';
                }else if(obj.pfType==10341002){
                    obj.pfTypeStr='配方信息错误';  
                }else if(obj.pfType==10341003){
                  obj.pfTypeStr='不当评论';
                } else if(obj.pfType==10341004){
                  obj.pfTypeStr='积分相关';
                }else if(obj.pfType==10341005){
                  obj.pfTypeStr='App 使用问题及建议';
                }else if(obj.pfType==10341006){
                  obj.pfTypeStr='其他';
                }

                self.list.push(pageList[i]);
            }
            self.loading = false; // 本次查询加载完成 
            let total=self.list.length; // 当前list 数量
            if (total >= dataTotal) {
              this.finished = true;
            }else{
              this.finished = false;
              self.page=self.page+1; //设置下一次加载页码
            }

          }else{
            Toast(res.data.msg);
          }

        
          
        }); 
       
    },

    detail(item) {
      this.$router.push({ name: 'feedbackDetail', params: { feedBackData: item } });
    },

  },
};

</script>

<style lang="scss" scoped>
#app {
    background-color: black;
}
body {
    background-color: #fff;
}

/deep/ .van-nav-bar__title {
  color: black !important;
  font-size: 1rem;
  font-weight: 600;
}
.div-conter {
    @supports (height: constant(safe-area-inset-top)) or
      (height: env(safe-area-inset-top)) {
        padding-top: 46px;
     // padding-top: calc(46px + constant(safe-area-inset-top));
      // padding-top: calc(46px + env(safe-area-inset-top));
    }
      width: 100%;
      overflow: hidden;
    
}

.icon-circle-class {
                font-size: 0.7rem;
                padding-top: 1px;
              }
       
  .icon-circleThree {
              all: initial;
              padding: 1px 5px;
              height: 1.1rem;
              border-radius: 10px;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: rgb(226,233,206);
              color:  rgb(109,148,25);
              font-size: .3733rem;
              padding-left: .2667rem;
              padding-right: .2667rem;
              padding-bottom: .17rem;
              // padding-top: .1;
              margin-right: .75rem;
              // margin-top: .7rem;
          }

          .borderCss{
        position: relative;
     }  

.borderCss:before {
  position: absolute;
  top: -0.5rem;
  left: 0;
  content: '';
  width: 100%;
  border-bottom: 1px solid #ebedf0; 
  transform: scaleY(0.5);
}     

</style>